import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import RedirectEditForm from './forms/EditRedirectForm';
import {fetchSites} from '../sites/thunks';
import {
    fetchRedirect,
    updateRedirect,
    fetchStatuses
} from './thunks';

import {getFormValues} from 'redux-form';

class RedirectEdit extends Component {

    componentWillMount() {
        this.props.fetchRedirect(this.props.match.params.id);
        this.props.fetchStatuses();
        this.props.fetchSites();
    }

    handleEditRedirectSubmit(formProps) {
        this.props.updateRedirect(formProps);
    }

    render() {
        return (
            this.props.loading !== true &&
            <RedirectEditForm
                statuses={this.props.statuses}
                sites={this.props.sites}
                initialValues={this.props.initialValues}
                classes={this.props.classes}
                handleFormSubmit={this.handleEditRedirectSubmit.bind(this)}
                touched={this.props.touched}
                loading={this.props.loading}
                redirect={this.props.redirect}
            /> 
        )
    }
}

const mapStateToProps = state => ({
    initialValues: {
        id: state.redirects.redirect.id,
        redirect_from: state.redirects.redirect.redirect_from,
        redirect_to: state.redirects.redirect.redirect_to,
        status: state.redirects.redirect.status,
        site_id: state.redirects.redirect.site_id,
        touched: state.redirects.touched,
    },
    statuses: state.redirects.statuses,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.redirects.touched,
    sites: state.sites.all,
    redirect: getFormValues('RedirectEditForm')(state),
});

export default connect(mapStateToProps, {
    fetchRedirect,
    updateRedirect,
    fetchStatuses,
    fetchSites
})(withStyles(styles)(RedirectEdit));


// WEBPACK FOOTER //
// ./src/containers/redirects/RedirectEdit.jsx